import React, { useState, useEffect, useCallback } from 'react'
import api from '../api'
import s3 from '../s3'

import { CheckCircleOutlined, CloseCircleOutlined, InboxOutlined } from '@ant-design/icons'
import { Button, Tag, Typography, message, Modal, Input, Table, Tooltip, Alert, Progress, Divider, Upload, Spin } from 'antd'

import { ProCard } from '@ant-design/pro-components'

import dayjs from 'dayjs'
// import 'dayjs/locale/zh-cn'

const { Dragger } = Upload
const { Paragraph, Title, Text } = Typography

var relativeTime = require('dayjs/plugin/relativeTime')
dayjs.extend(relativeTime)


// dayjs.locale('zh-cn')


function toPercentage(part, total) {
    if (total === 0) return '0%';
    // return ((part / total) * 100).toFixed(decimals) + '%';
    return ((part / total) * 100);
}


//  控制台-NZ云存储
function Nzcos(props) {
    const [get, setGet] = useState(true)
    const [data, setData] = useState({ gip: [], token: '', member: '普通', url: '' })
    const [rosdata, setRosData] = useState({ Data: { UsageData: {}, Plan: {}, ExpDate: 0 }, buy: false, bucketData: { name: '' }, })

    // const [data, setData] = useState('无')

    // function isImage(file) {
    //     const acceptedImageTypes = ['image/gif', 'image/jpeg', 'image/png', 'image/webp']
    //     return file && acceptedImageTypes.includes(file)
    // }

    //  文件上传
    const uploadProps = {
        name: 'cdn',
        maxCount: 1,
        style: {
            marginTop: 20
        },
        customRequest(info) {
            // if (!isImage(info.file.type)) {
            //     message.error('请上传图片类型的文件,只支持gif、jpeg、png、webp等多种的图片格式')
            //     info.onError()
            //     return
            // }
            if (info.file.size > 1245728000) {
                message.error('文件大小超过10MB,无法上传')
                info.onError()
                return
            }

            s3.upload({
                type: 'cdn',
                file: info.file,
                name: info.file.name,
                size: info.file.size,
                ros: true,
            }, (msg) => {
                if (msg.text) {
                    message.error(msg.text)
                    return
                }

                setData({ ...data, url: msg.url })
                info.onSuccess()
                message.success('上传成功')
            })
        },
    }


    useEffect(() => {
        let name = 'userMemberData'
        if (localStorage.getItem(name)) {
            setData(JSON.parse(localStorage.getItem(name)))
        }

        api.get('/api/v2/user/get', {
            params: {
                name: 'member',
            }
        })
            .then((res) => {
                if (res.data.code === 200) {
                    let Data = res.data.data.data.Data
                    localStorage.setItem(name, JSON.stringify(Data))
                    setData(Data)
                } else {
                    message.error(res.data.data.text)
                }
            })
            .catch((error) => {
                message.error('网络异常,无法连接服务器')
            })

        getRos()
    }, [])

    async function getRos() {
        api.get('/api/v2/user/get', {
            params: {
                name: 'ros',
            }
        })
            .then((res) => {
                if (res.data.code === 200) {
                    let Data = res.data.data.data.Data
                    if (Data.get) {
                        setGet(true)
                        setTimeout(() => {
                            getRos()
                        }, 500);
                        return
                    }

                    setGet(false)

                    setRosData({ ...rosdata, ...Data.ros })
                } else {
                    message.error(res.data.data.text)
                }
            })
            .catch((error) => {
                message.error('网络异常,无法连接服务器')
            })
    }

    async function TogglePublicAccess(value) {
        api.post('/api/v2/user/update', {
            type: 'RosTogglePublicAccess',
            value: value,
        })
            .then((res) => {
                if (res.data.code === 200) {
                    message.success('修改成功')
                } else {
                    message.error(res.data.data.text)
                }

                setTimeout(() => {
                    getRos()
                }, 500);
            })
            .catch((error) => {
                message.error('网络异常,无法连接服务器')
            })
    }



    return (
        <div>

            {/* <Alert
                message="下线通知"
                description="此服务准备下线, 具体请观看上方的置顶通知"
                type="warning"
                showIcon
                style={{ marginBottom: 20 }}
            /> */}

            <ProCard style={{ borderColor: '#313131', color: '#fff', backgroundColor: '#141414', width: '100%' }} bordered>
                <Title level={5} style={{ marginTop: 0, marginBottom: 20, fontWeight: 400 }} > NZ云存储 V2 <Tag color="processing">New</Tag></Title>

                {get ? <>
                    <Alert
                        message={<>数据加载中 <Spin /> </>}
                        description={<>正在获取数据, 可能需要数秒钟等待~</>}
                        // type="warning"
                        showIcon
                        style={{ marginBottom: 20 }}
                    />
                </> : <>
                    {rosdata.buy ?
                        <>
                            <div>
                                <Title level={5} style={{ marginTop: 0, marginBottom: 10, fontWeight: 400 }} > 存储块 #{rosdata.Data.ID}</Title>
                                <div style={{ width: 200 }}>
                                    套餐: {rosdata.Data.Plan.chinese}
                                </div>
                                <div>
                                    到期时间: {dayjs(dayjs(parseInt(rosdata.Data.ExpDate) * 1000)).format('YYYY年MM月DD日 HH:mm')}
                                </div>
                                <div style={{ width: '100%' }}>
                                    存储桶名称: {rosdata.bucketData.name} #{rosdata.bucketData.id}
                                </div>
                                <div style={{ width: '100%' }}>
                                    公共访问: {rosdata.bucketData.is_public_access ? <><Tag color="success">已开启访问</Tag></> : <><Tag color="error">未开启访问</Tag> <Button type="primary" size='small' onClick={() => { TogglePublicAccess(rosdata.bucketData.id) }}>开启</Button></>}
                                </div>
                                <div style={{ width: 200 }}>
                                    存储 {((rosdata.Data.UsageData.metrics_usage_total_bytes / 1024) / 1024).toFixed(1)} MB / {rosdata.Data.Plan.storage_size}G <Progress percent={toPercentage(((rosdata.Data.UsageData.metrics_usage_total_bytes / 1024) / 1024), (rosdata.Data.Plan.storage_size * 1024))} showInfo={false} />
                                </div>
                                <div style={{ width: 200 }}>
                                    流量 {((rosdata.Data.UsageData.metrics_sent_bytes / 1024) / 1024).toFixed(1)} MB / {rosdata.Data.Plan.bandwidth}G <Progress percent={toPercentage(((rosdata.Data.UsageData.metrics_sent_bytes / 1024) / 1024), (rosdata.Data.Plan.bandwidth * 1024))} showInfo={false} />
                                </div>

                                {/* <Button type="primary" style={{ float: 'right' }} >→ 续费产品</Button> */}

                                {rosdata.bucketData.url ?
                                    <div>
                                        访问地址: https://{rosdata.bucketData.url} (绑定域名)
                                    </div>
                                    : <div>
                                        访问地址: https://{rosdata.bucketData.name}.{rosdata.Data.public_api_url} (临时测试地址)
                                    </div>}

                                <Divider />
                                <ProCard style={{ borderColor: '#313131', color: '#fff', backgroundColor: '#141414', width: '100%' }} bordered>
                                    <Title level={5} style={{ marginTop: 0, marginBottom: 0, fontWeight: 400 }} > 存储块文件快捷上传</Title>
                                    <Text type="secondary">在此处上传的文件会占用并消耗你的存储块产品的存储和流量资源, 请注意资源消耗情况, 同时暂不支持对已上传文件进行删除和查看操作, 我们尽快提供此功能。</Text>

                                    <Dragger {...uploadProps}>
                                        <p className="ant-upload-drag-icon">
                                            <InboxOutlined />
                                        </p>
                                        <p className="ant-upload-text">点击或拖拽文件到此区域上传</p>
                                        <p className="ant-upload-hint">
                                            最大可支持文件大小为1024MB以内的单个文件上传, 请遵守中国法律法规, 禁止上传色情等违法图片、视频、文件内容。
                                        </p>
                                    </Dragger>
                                    <div style={{ marginTop: 20 }}>
                                        <Paragraph copyable={{ text: data.url }}>外链地址: {data.url}</Paragraph>
                                    </div>
                                </ProCard>
                            </div>
                        </>
                        :

                        <Alert
                            message="暂无存储块"
                            description="需要购买存储块才能正常使用此功能, 请在 产品中心/存储块 进行购买!"
                            type="warning"
                            showIcon
                            style={{ marginBottom: 20 }}
                        />
                    }
                </>}



                {rosdata.buy ?
                    <>
                        <Divider />

                        <Alert
                            message="接口使用限制"
                            description="目前机制限制是图片单文件大小为5mb, 视频单文件大小为50mb, 同时不得恶意滥用视频上传的接口, 如发现大量上传视频文件则会进一步处理的!"
                            type="info"
                            showIcon
                            style={{ marginBottom: 20 }}
                        />

                        <Title level={5} style={{ marginTop: 0, marginBottom: 10, fontWeight: 400 }} > 图片上传接口</Title>


                        <div style={{ marginTop: 20, marginBottom: 20 }}>
                            lb-phone 插件使用教程地址:  <a href="https://docs.qq.com/doc/DUUxJWGdZd29SU1RK" target="_blank" rel="noopener noreferrer">https://docs.qq.com/doc/DUUxJWGdZd29SU1RK</a>
                        </div>


                        <Paragraph
                            copyable={{
                                text: `https://u.n2yun.com.cn/imgs?token=${data.token}`,
                            }}
                            style={{ marginBottom: 0 }}
                        >
                            接口地址: <Tag color="processing">https://u.n2yun.com.cn/imgs?token={data.token}</Tag>
                        </Paragraph>
                        <Title level={5} style={{ marginTop: 20, marginBottom: 10, fontWeight: 400 }} > 视频上传接口</Title>
                        <Paragraph
                            copyable={{
                                text: `https://u.n2yun.com.cn/video?token=${data.token}`,
                            }}
                            style={{ marginBottom: 0 }}
                        >
                            接口地址: <Tag color="processing">https://u.n2yun.com.cn/video?token={data.token}</Tag>
                        </Paragraph>
                        <Title level={5} style={{ marginTop: 20, marginBottom: 10, fontWeight: 400 }} > 音频上传接口</Title>
                        <Paragraph
                            copyable={{
                                text: `https://u.n2yun.com.cn/audio?token=${data.token}`,
                            }}
                            style={{ marginBottom: 0 }}
                        >
                            接口地址: <Tag color="processing">https://u.n2yun.com.cn/audio?token={data.token}</Tag>
                        </Paragraph>
                    </> : <>
                    </>}


            </ProCard>
        </div>
    )
}

export default Nzcos;